import React, { useMemo, useState } from "react";
import { Button, Table, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { convertUtcToIst } from "../../../../helpers/utility";
import AddVitalsModal from "./AddVitalsModal";
import { getGrbsRows } from "./vitalsGrbs";

const { Text } = Typography;

const RECENT_COUNT = 5;

const Vitals = ({ details, admissionId, onVitalsAdded, canAdd = true }) => {
  const vitals = details?.data?.vitals;
  const [openAdd, setOpenAdd] = useState(false);

  const recentVitals = useMemo(() => {
    if (!Array.isArray(vitals)) return [];
    return [...vitals]
      .sort((a, b) => dayjs(b?.action_time).valueOf() - dayjs(a?.action_time).valueOf())
      .slice(0, RECENT_COUNT);
  }, [vitals]);

  /* Same split the forms submit, so what is shown and what is saved agree. */
  const recentGrbs = useMemo(
    () => getGrbsRows(details?.data).slice(0, RECENT_COUNT),
    [details]
  );

  const columns = [
    {
      title: "Started On",
      dataIndex: "action_time",
      key: "action_time",
      render: (value) => convertUtcToIst(value, true, true),
    },
    {
      title: "Temperature",
      dataIndex: "temperature",
      width: "10%",
    },
    {
      title: "Pulse Rate",
      dataIndex: "pulse",
      width: "10%",
    },
    {
      title: "Respiratory Rate",
      dataIndex: "respiration",
      width: "10%",
    },
    {
      title: "SPO2",
      dataIndex: "oxygen_saturation",
      width: "10%",
    },
    {
      title: "Systolic Pressure",
      dataIndex: "systolic_pressure",
      width: "10%",
    },
    {
      title: "Diastolic Pressure",
      dataIndex: "diastolic_pressure",
      width: "10%",
    },
  ];

  /* GRBS and insulin are recorded on their own chart, not as part of a vitals
     reading, and the backend sends them as their own list. They were being
     shown as two more columns of the vitals table, which read as though every
     vitals round also took a sugar. They get their own table. */
  const grbsColumns = [
    {
      title: "Taken On",
      dataIndex: "action_time",
      key: "action_time",
      render: (value) => convertUtcToIst(value, true, true),
    },
    {
      title: "GRBS",
      dataIndex: "grbs",
      width: "20%",
    },
    {
      title: "Insulin",
      dataIndex: "insulin",
      width: "20%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (value) => value || "-",
    },
  ];

  return (
    <div>
      <div className="forms-ip-vitals-header">
        <Text type="secondary">
          Showing the {RECENT_COUNT} most recent readings
        </Text>
        {canAdd && (
          <Button
            icon={<PlusOutlined />}
            onClick={() => setOpenAdd(true)}
            disabled={!admissionId}
          >
            Add Record
          </Button>
        )}
      </div>
      <Table
        dataSource={recentVitals}
        rowKey={(record, index) => record?.id ?? index}
        pagination={false}
        columns={columns}
        scroll={{ x: "400px" }}
      />

      <Text strong className="forms-ip-subsection-title">
        GRBS
      </Text>
      <Table
        dataSource={recentGrbs}
        rowKey={(record, index) => record?.id ?? index}
        pagination={false}
        columns={grbsColumns}
        scroll={{ x: "400px" }}
      />

      {openAdd && (
        <AddVitalsModal
          open={openAdd}
          setOpen={setOpenAdd}
          admissionId={admissionId}
          onSaved={onVitalsAdded}
        />
      )}
    </div>
  );
};

export default Vitals;
